// @file: src/pages/scales/ExtraScale.js
// Componente de escala extra da TV

import { Container } from "./styles";

const ExtraScale = ({ scale }) => {
  // Normaliza o array de escalas extras
  const extra = Array.isArray(scale) ? scale : [];

  return (
    <Container className="text-center">
      <h5 className="text-center mb-3">ESCALA EXTRA</h5>

      {/* Bloco 0 */}
      <div className="d-flex">
        <h6 className="col-1 fw-bold extra-h6">UR/UCI</h6>
        <p className="col extra-p">{extra[0]?.vehicle?.number}</p>
      </div>

      <div className="d-flex">
        <h6 className="col-1 extra-h6">MOT</h6>
        <p className="col extra-p">
          {extra[0]?.fighters_scales?.[0]?.fighter?.nickname}
        </p>
      </div>

      <div className="d-flex">
        <h6 className="col-1 extra-h6">BV</h6>
        <p className="col extra-p">
          {extra[0]?.fighters_scales?.[1]?.fighter?.nickname}
        </p>
      </div>

      <div className="d-flex">
        <h6 className="col-1 extra-h6">BV</h6>
        <p className="col extra-p">
          {extra[0]?.fighters_scales?.[2]?.fighter?.nickname}
        </p>
      </div>

      {/* <hr /> */}

      {/* Bloco 1 */}
      <div className="d-flex">
        <h6 className="col-1 fw-bold extra-h6">UR/UCI</h6>
        <p className="col extra-p">{extra[1]?.vehicle?.number}</p>
      </div>

      <div className="d-flex">
        <h6 className="col-1 extra-h6">MOT</h6>
        <p className="col extra-p">
          {extra[1]?.fighters_scales?.[0]?.fighter?.nickname}
        </p>
      </div>

      <div className="d-flex">
        <h6 className="col-1 extra-h6">BV</h6>
        <p className="col extra-p">
          {extra[1]?.fighters_scales?.[1]?.fighter?.nickname}
        </p>
      </div>

      <div className="d-flex">
        <h6 className="col-1 extra-h6">BV</h6>
        <p className="col extra-p">
          {extra[1]?.fighters_scales?.[2]?.fighter?.nickname}
        </p>
      </div>

      {/* <hr /> */}

      {/* Bloco 2 */}
      <div className="d-flex">
        <h6 className="col-1 fw-bold extra-h6">UR/UCI</h6>
        <p className="col extra-p">{extra[2]?.vehicle?.number}</p>
      </div>

      <div className="d-flex">
        <h6 className="col-1 extra-h6">MOT</h6>
        <p className="col extra-p">
          {extra[2]?.fighters_scales?.[0]?.fighter?.nickname}
        </p>
      </div>

      <div className="d-flex">
        <h6 className="col-1 extra-h6">BV</h6>
        <p className="col extra-p">
          {extra[2]?.fighters_scales?.[1]?.fighter?.nickname}
        </p>
      </div>

      <div className="d-flex">
        <h6 className="col-1 extra-h6">BV</h6>
        <p className="col extra-p">
          {extra[2]?.fighters_scales?.[2]?.fighter?.nickname}
        </p>
      </div>

      {/* <hr /> */}

      {/* Bloco 3 */}
      <div className="d-flex">
        <h6 className="col-1 fw-bold extra-h6">UR/UCI</h6>
        <p className="col extra-p">{extra[3]?.vehicle?.number}</p>
      </div>

      <div className="d-flex">
        <h6 className="col-1 extra-h6">MOT</h6>
        <p className="col extra-p">
          {extra[3]?.fighters_scales?.[0]?.fighter?.nickname}
        </p>
      </div>

      <div className="d-flex">
        <h6 className="col-1 extra-h6">BV</h6>
        <p className="col extra-p">
          {extra[3]?.fighters_scales?.[1]?.fighter?.nickname}
        </p>
      </div>

      <div className="d-flex">
        <h6 className="col-1 extra-h6">BV</h6>
        <p className="col extra-p">
          {extra[3]?.fighters_scales?.[2]?.fighter?.nickname}
        </p>
      </div>
    </Container>
  );
};

export default ExtraScale;
